import { render, staticRenderFns } from "./InputTextareaHorizontal.vue?vue&type=template&id=8b6426a6&scoped=true&lang=pug"
import script from "./InputTextareaHorizontal.vue?vue&type=script&lang=ts"
export * from "./InputTextareaHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./InputTextareaHorizontal.vue?vue&type=style&index=0&id=8b6426a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6426a6",
  null
  
)

export default component.exports